import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { func, node } from 'prop-types';
import styled from 'styled-components';
import Circle from './Circle';
import { getLastProfilePhotoUploadDate, hasProfilePhoto } from '../../../core/util/account';
import { isEmptyObject } from '../../../core/util/object';
import { FETCH_USER_PROFILE_PHOTO } from '../../../ducks/userProfilePhotos';

const Root = styled.div.withConfig({ componentId: 'sc-12tvap-0' })`
  display: inline-block;
`;

const RelativeContainer = styled(({ size, ...rest }) => <div {...rest} />).withConfig({ componentId: 'sc-12tvap-1' })`
  position: relative;
  top: 0;
  left: 0;
  height: ${(props) => props.size}px;
`;

type OwnAvatarProps = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  handleAvatarClick?: func;
  userProfilePhotos?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  fetchProfilePhoto?: func;
  profileColor?: string;
  userProfile?: object;
  // @ts-expect-error ts-migrate(2749) FIXME: 'node' refers to a value, but is being used as a t... Remove this comment to see the full error message
  clickIcon?: node;
  className?: string;
  size?: number;
};

type AvatarProps = OwnAvatarProps & typeof Avatar.defaultProps;

class Avatar extends PureComponent<AvatarProps> {
  static defaultProps = {
    userProfile: {},
    size: 40,
  };

  getProfilePhoto = () => {
    const { userProfile, userProfilePhotos } = this.props;

    if (!hasProfilePhoto(userProfile)) return null;
    if (!this.savedPhotoIsValid()) {
      this.fetchProfilePhoto();
      return null;
    }

    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const { src } = userProfilePhotos[userProfile.user_profile_id];
    return src;
  };

  savedPhotoIsValid = () => {
    const { userProfile, userProfilePhotos } = this.props;
    const photoUploadDate = getLastProfilePhotoUploadDate(userProfile);
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const photoObj = userProfilePhotos[userProfile.user_profile_id];

    return photoObj && photoObj.fetchDate > photoUploadDate;
  };

  fetchProfilePhoto = () => {
    const { userProfilePhotos, fetchProfilePhoto, userProfile } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const photoObj = userProfilePhotos[userProfile.user_profile_id];
    if (photoObj && photoObj.fetching) return;

    fetchProfilePhoto(userProfile);
  };

  render() {
    const { handleAvatarClick, profileColor, userProfile, className, size } = this.props;

    if (isEmptyObject(userProfile)) return null; //TODO use a placeholder
    const src = this.getProfilePhoto() || undefined;

    return (
      <Root>
        <RelativeContainer className={className} size={size}>
          <Circle
            backgroundColor={src ? undefined : profileColor}
            className={className}
            handleClick={handleAvatarClick}
            size={size}
            src={src}
          >
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'first_name' does not exist on type 'obje... Remove this comment to see the full error message */}
            {userProfile.first_name.slice(0, 1).toUpperCase()}
            {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'last_name' does not exist on type 'objec... Remove this comment to see the full error message */}
            {userProfile.last_name.slice(0, 1).toUpperCase()}
          </Circle>
        </RelativeContainer>
      </Root>
    );
  }
}

const mapStateToProps = (state: any) => ({
  userProfilePhotos: state.userProfilePhotos,
});

const mapDispatchToProps = (dispatch: any) => ({
  fetchProfilePhoto: (userProfile: any) =>
    dispatch({ type: FETCH_USER_PROFILE_PHOTO, userProfile }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Avatar);
